import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import type { Space } from "@circle-react/types";
import { LinkIcon } from "./LinkIcon";
import { ManageBookmarkActions } from "./ManageBookmarkActions";

export interface LinkBookmarkIconProps {
  bookmark: any;
  onDeleteClick?: (bookmark?: any) => void;
  onEditClick?: (bookmark?: any) => void;
  space: Space;
}

export const LinkBookmarkIcon = ({
  space,
  bookmark,
  onEditClick,
  onDeleteClick,
}: LinkBookmarkIconProps) => {
  const canManageBookmark = userIsAdminOrModeratorOfSpace(space);

  if (!canManageBookmark) {
    return (
      <span className="flex size-5">
        <LinkIcon bookmark={bookmark} />
      </span>
    );
  }

  return (
    <span className="flex size-5">
      <span className="flex size-5 justify-center group-hover:invisible">
        <LinkIcon bookmark={bookmark} />
      </span>
      <span className="invisible -ml-5 size-5 group-hover:visible">
        <ManageBookmarkActions
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          bookmark={bookmark}
        />
      </span>
    </span>
  );
};
